import { useSearchParams } from "react-router-dom";

const QUERY_KEY = "query";
const TAGS_KEY = "tags";

export const useMediaSearch = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const setSearchCriteria = ({ text, tags = [] }: { text: string; tags: string[] }) =>
    setSearchParams((prev) => {
      if (text) {
        prev.set(QUERY_KEY, text);
      } else {
        prev.delete(QUERY_KEY);
      }
      if (tags.length > 0) {
        prev.set(TAGS_KEY, tags.join(","));
      } else {
        prev.delete(TAGS_KEY);
      }
      return prev;
    });

  const clear = () => setSearchParams(new URLSearchParams());

  return {
    searchCriteria: {
      text: searchParams.get(QUERY_KEY) ?? "",
      tags: searchParams.get(TAGS_KEY)?.split(",") ?? [],
    },
    setSearchCriteria,
    clear,
  };
};
